import {HearthstoneSet} from "./Sets/HearthstoneSet.ts";
import {MusicGenresSet} from "./Sets/MusicGenresSet.ts";
import {KeywordEntity} from "../Entity/KeywordEntity.ts";

export interface KeywordSet{
	readonly id: string;
	readonly name: string;
	readonly description: string;
	readonly time: number;
	readonly keywords: string[];
}

export function findById(id: string): KeywordSet|undefined {
	return getAllSets().find((set: KeywordSet): boolean => set.id === id);
}

export function getAllSets(): KeywordSet[] {
	return [HearthstoneSet, MusicGenresSet];
}

export function convert(keywords: string[]): KeywordEntity[] {
	return keywords
		.toSorted((a: string, b:string): number => a.localeCompare(b))
		.map((keyword: string):KeywordEntity => ({name: keyword, hidden: true, guessed: false}));
}
